export const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;
export const ATTRIBUTES_URL = `${process.env.REACT_APP_BASE_URL}/api/attributes`;
export const PRODUCTS_URL = `${process.env.REACT_APP_BASE_URL}/api/products`;
export const PRODUCT_GROUPS_URL = `${process.env.REACT_APP_BASE_URL}/api/product_groups`;
export const PRODUCT_GROUP_ASSOCIATIONS_URL = `${process.env.REACT_APP_BASE_URL}/api/product_group_associations`;
export const PRODUCT_GROUP_COMMON_ASSOCIATIONS_URL = `${process.env.REACT_APP_BASE_URL}/api/product_group_associations/common`;
export const CONFIGURE_URL = `${process.env.REACT_APP_BASE_URL}/api/configure`;
